// On-device blur & low-light heuristics. Runs entirely in the browser on a
// downscaled grayscale copy so it is fast and never leaves the device.
export function analyzeImageQuality(dataUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const S = 96;
      const c = document.createElement("canvas");
      c.width = S;
      c.height = S;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, S, S);
      const { data } = ctx.getImageData(0, 0, S, S);

      const gray = new Float64Array(S * S);
      let sum = 0;
      for (let i = 0, p = 0; i < data.length; i += 4, p++) {
        const g = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        gray[p] = g;
        sum += g;
      }
      const brightness = sum / (S * S); // 0..255

      // Laplacian variance = sharpness (higher = crisper)
      let lapSum = 0;
      let lapSq = 0;
      let n = 0;
      for (let y = 1; y < S - 1; y++) {
        for (let x = 1; x < S - 1; x++) {
          const idx = y * S + x;
          const lap =
            4 * gray[idx] -
            gray[idx - 1] -
            gray[idx + 1] -
            gray[idx - S] -
            gray[idx + S];
          lapSum += lap;
          lapSq += lap * lap;
          n++;
        }
      }
      const mean = lapSum / n;
      const sharpness = lapSq / n - mean * mean;

      const tooDark = brightness < 45;
      const tooBright = brightness > 235;
      const blurry = sharpness < 120;
      resolve({
        brightness: Math.round(brightness),
        sharpness: Math.round(sharpness),
        tooDark,
        tooBright,
        blurry,
        ok: !tooDark && !tooBright && !blurry,
      });
    };
    img.onerror = () => resolve({ ok: true, brightness: 0, sharpness: 0, tooDark: false, tooBright: false, blurry: false });
    img.src = dataUrl;
  });
}
